import snakecaseKeys from 'snakecase-keys';
import { CosmosGovV1Tx, CosmosGovV1Gov } from '@injectivelabs/core-proto-ts';
import { MsgBase } from '../../MsgBase.js';
/**
 * @category Messages
 */
export default class MsgVote extends MsgBase {
    static fromJSON(params) {
        return new MsgVote(params);
    }
    toProto() {
        const { params } = this;
        const message = CosmosGovV1Tx.MsgVote.create();
        message.proposalId = params.proposalId.toString();
        message.voter = params.voter;
        message.option = params.vote;
        message.metadata = params.metadata || '';
        return message;
    }
    toData() {
        const proto = this.toProto();
        return {
            '@type': '/cosmos.gov.v1.MsgVote',
            ...proto,
        };
    }
    toAmino() {
        const proto = this.toProto();
        const message = {
            ...snakecaseKeys(proto),
            option: proto.option,
        };
        return {
            type: 'cosmos-sdk/v1/MsgVote',
            value: message,
        };
    }
    toWeb3Gw() {
        const amino = this.toAmino();
        const { value } = amino;
        return {
            '@type': '/cosmos.gov.v1.MsgVote',
            ...value,
        };
    }
    toEip712V2() {
        const web3Gw = this.toWeb3Gw();
        web3Gw.option = CosmosGovV1Gov.voteOptionToJSON(web3Gw.option);
        return web3Gw;
    }
    toDirectSign() {
        const proto = this.toProto();
        return {
            type: '/cosmos.gov.v1.MsgVote',
            message: proto,
        };
    }
    toBinary() {
        return CosmosGovV1Tx.MsgVote.encode(this.toProto()).finish();
    }
}
